module.exports = __webpack_public_path__ + "img/cart-icon-bold.9431b406.png";